import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FormDivider from '../common/components/FormDivider'
import AutomatedRemindersSection from '../common/components/formInputs/AutomatedRemindersSection'
import SwitchInput from '../common/components/formInputs/SwitchInput'
import { getVisibilityOptions } from '../common/helpers'

const ThirdStep = ({ displayStep, formValues, setFieldValue }) => {
  const { t } = useTranslation(['eventManagement'])

  if (!displayStep) {
    return null
  }

  return (
    <React.Fragment>
      <FormDivider />
      <div className="columns">
        <div className="column is-12">
          <p>{t('eventManagement:common.communication')}</p>
        </div>
      </div>
      <AutomatedRemindersSection
        automatedRemindersToggle={formValues.automatedRemindersToggle}
        remindAll={formValues.remindAll}
        remindAllValues={formValues.remindAllValues}
        timeStart={formValues.timeStart}
        setFieldValue={setFieldValue}
        displayRemindRsvpSection={false}
      />
      <FormDivider />
      <SwitchInput
        columnSize={12}
        label={t('eventManagement:common.visibility')}
        name="isPrivate"
        value={formValues.isPrivate}
        tooltip={<p>{t('eventManagement:common.visibilityTooltip')}</p>}
        options={getVisibilityOptions(t)}
        setFieldValue={setFieldValue}
      />
    </React.Fragment>
  )
}

ThirdStep.propTypes = {
  displayStep: PropTypes.bool,
  formValues: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
}

export default ThirdStep
